/*
* 合同类型
* */
export const contractType = [
  {value: 1, label: '买卖合同'},
  {value: 2, label: '供用电、水、气、热力合同'},
  {value: 3, label: '赠与合同'},
  {value: 4, label: '借款合同'},
  {value: 5, label: '租赁合同'},
  {value: 6, label: '融资租赁合同'},
  {value: 7, label: '承揽合同'},
  {value: 8, label: '建筑工程合同'},
  {value: 9, label: '运输合同'},
  {value: 10, label: '技术合同'},
  {value: 11, label: '保管合同'},
  {value: 12, label: '仓储合同'},
  {value: 13, label: '委托合同'},
  {value: 14, label: '行纪合同'},
  {value: 15, label: '居间合同'},
  {value: 16, label: '无名合同'},
  {value: 17, label: '其他'},
]

/*
* 合同类型
* */
export const contractLevel = [
  {value: 1, label: '绝密'},
  {value: 2, label: '机密'},
  {value: 3, label: '秘密'},
  {value: 4, label: '公开'},
]

/*
* 签署方
* */
export const signedNum = [
  {value: 1, label: '双方签署'},
  {value: 2, label: '三方签署'},
]

/*
* 付款方式
* */
export const paymentType = [
  {value: 1, label: '首付款'},
  {value: 2, label: '第二阶段'},
  {value: 3, label: '第三阶段'},
  {value: 4, label: '第四阶段'},
  {value: 5, label: '尾款'},
]



/*
* 币种
* */
export const currencyType = [
  {value: 'RMB', label: '人民币'},
]


/*
* 数据过滤全部
* */
export const optionList = (state, arr) => {
  if (state) {
    return arr
  } else {
    return arr.slice(1)
  }
}

/*
* value转换为label
* */
export const filesCN = (val, arr) => {
  if (val) {
    let _str = arr.filter(item => val === item.value)
    return _str[0].label
  } else {
    return ''
  }

}


/*
* 时间转换
* */
export const zhDate = (date, type) => {
  let now = new Date(date)
  let year = now.getFullYear()
  let month = now.getMonth() + 1
  let day = now.getDate()
  let hour = now.getHours()
  let minute = now.getMinutes()
  let second = now.getSeconds()
  if (type === 1) {
    return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute)
  } else if (type === 2) {
    return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
  } else if (type === 3) {
    return getzf(hour) + ":" + getzf(minute)
  } else if (type === 4) {
    return year
  } else if (type === 5) {
    return month
  } else {
    return year + "-" + getzf(month) + "-" + getzf(day)
  }
}

function getzf(num) {
  if (parseInt(num) < 10) {
    num = '0' + num
  }
  return num
}


export const digitUppercase = (price) => {
  const fraction = ['角', '分']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ]
  let num = Math.abs(price)
  let s = ''
  fraction.forEach((item, index) => {
    s += (digit[Math.floor(num * 10 * (10 ** index)) % 10] + item).replace(/零./, '')
  })
  s = s || '整'
  num = Math.floor(num)
  for (let i = 0; i < unit[0].length && num > 0; i += 1) {
    let p = ''
    for (let j = 0; j < unit[1].length && num > 0; j += 1) {
      p = digit[num % 10] + unit[1][j] + p
      num = Math.floor(num / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }

  return s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
}


export const getDateNum=()=> {
  var myDate = new Date();
  //获取当前年
  var year = myDate.getFullYear();
  //获取当前月
  var month = myDate.getMonth() + 1;
  //获取当前日
  var date = myDate.getDate();
  var h = myDate.getHours(); //获取当前小时数(0-23)
  var m = myDate.getMinutes(); //获取当前分钟数(0-59)
  var s = myDate.getSeconds();
  //获取当前时间
  var now = year + conver(month) + conver(date) + conver(h) + conver(m) + conver(s) + "_";
  return now;
}
function conver(s) {
  return s < 10 ? '0' + s : s;
}
